import { generateUrl } from "@services/generateUrl/generateUrl"
import { onRequestSuccess, onResponseRejected } from "@services/interceptors"
import axios from "axios"

const STRIPE_URL = generateUrl()

const fcPaymentServiceApiInstance = axios.create({
    baseURL: `${STRIPE_URL}/fc-payment/api/v1`
})

fcPaymentServiceApiInstance.interceptors.request.use(onRequestSuccess, undefined)
fcPaymentServiceApiInstance.interceptors.response.use(undefined, onResponseRejected)

export default fcPaymentServiceApiInstance
